/*
 * Copyright (C) 2021 IHS Markit.
 * All Rights Reserved
 *
 * NOTICE: All information contained herein is, and remains
 * the property of IHS Markit and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to IHS Markit and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from IHS Markit.
 */
export class PagingModel {
  pageSizes: string[];
  pageSize: number;
  offset: number;
  visibleRows: number;
  totalRows: number;
  page: number;
  totalPages: number; // starts from 0 index
  specificPageButtons: any[];

  constructor(pageSize?: number, page?: number, pageSizes?: string[]) {
    this.pageSize = pageSize ? pageSize : 15;
    this.page = page ? page : 0;
    this.pageSizes = pageSizes && pageSizes.length > 0 ? pageSizes : ['10', '15', '30', '50'];

    this.offset = 0;
    this.visibleRows = 0;
    this.totalRows = 0;
    this.totalPages = 0;
    this.specificPageButtons = [];
  }
}

